import { useState } from 'react';
import { ConsumableDefinitionView, ConsumableType } from '../../types';
import './Dashboard.css';

interface ConsumablesPanelProps {
  definitions: ConsumableDefinitionView[];
  onAdminister: (type: ConsumableType) => Promise<void>;
}

export function ConsumablesPanel({ definitions, onAdminister }: ConsumablesPanelProps) {
  const [loading, setLoading] = useState<ConsumableType | null>(null);

  const handleClick = async (type: ConsumableType) => {
    if (loading) return;
    setLoading(type);
    try {
      await onAdminister(type);
    } catch {
      // Error is handled by the hook
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="panel consumables-panel">
      <h3 className="panel-title">Give Hannah</h3>
      <div className="consumables-grid">
        {definitions.map(def => {
          const isMaxed = def.activeStacks >= def.maxStacks;
          const isLoading = loading === def.type;

          return (
            <button
              key={def.type}
              className={`consumable-card ${isMaxed ? 'maxed' : ''} ${isLoading ? 'loading' : ''} consumable-${def.type}`}
              onClick={() => handleClick(def.type)}
              disabled={isMaxed || isLoading}
              title={def.description}
            >
              <span className="consumable-icon">{def.icon}</span>
              <span className="consumable-label">{def.label}</span>
              <div className="consumable-dots">
                {Array.from({ length: def.maxStacks }).map((_, i) => (
                  <span
                    key={i}
                    className={`consumable-dot ${i < def.activeStacks ? 'active' : ''}`}
                  />
                ))}
              </div>
              {isMaxed && <span className="consumable-maxed">Max</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
